<template>
  <v-card class="mt-8">
    <v-layout class="px-4 py-4">
      <h3>Shift Start/End Address</h3>
      <v-spacer></v-spacer>
      <v-btn
        v-if="items.length > 0 && !no_data.includes(staff)"
        sx12
        class="mr-0 mt-0"
        color="primary"
        small
        :disabled="staff.status !== 'active'"
        @click="vEmit({ name: 'EditShiftAddress', data: { items, edit: 'all' } })"
      >
          <v-icon left>create</v-icon>
          Edit
      </v-btn>
    </v-layout>
    <v-divider></v-divider>
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :loading="loading"
      loader-height="2"
      hide-default-footer
      class="my-sticky-last-column-table"
      mobile-breakpoint="100"
    >
      <template v-slot:item="{item}">
        <tr class="items-body-row">
          <td>
            <template v-if="!sameServiceDays">
              <span v-if="!no_data.includes(item.day)">
                {{ days.find(i => i.id === Number(item.day) + 1).name }}
              </span>
              <em v-else class="grey--text">No Data</em>
            </template>
            <span v-else>All (Mon, Tue, Wed, Thu, Fri, Sat, Sun)</span>
          </td>
          <td>
            <span 
              v-if="!no_data.includes(item.start_address) ||
                    !no_data.includes(item.start_city) ||
                    !no_data.includes(item.start_state) ||
                    !no_data.includes(item.start_zip)"
            >{{ `${!no_data.includes(item.start_address) ? item.start_address + ', ' : '' 
                }${!no_data.includes(item.start_city) ? item.start_city  + ', ' : ''
                }${!no_data.includes(item.start_state) ? stateAbbr(item.start_state)  + ' ' : ''
                }${item.start_zip}` }}
            </span>
            <em v-else class="grey--text">No Data</em>
          </td>
          <td>
            <span
              v-if="!no_data.includes(item.end_address) ||
                    !no_data.includes(item.end_city) ||
                    !no_data.includes(item.end_state) ||
                    !no_data.includes(item.end_zip)"
            >{{ `${!no_data.includes(item.end_address) ? item.end_address + ', ' : ''
                }${!no_data.includes(item.end_city) ? item.end_city + ', ' : ''
                }${!no_data.includes(item.end_state) ? stateAbbr(item.end_state) + ' ' : ''
                }${item.end_zip}` }}
            </span>
            <em v-else class="grey--text">No Data</em>
          </td>
          <td>
            <v-flex style="min-width: 65px;">
              <template v-if="!no_data.includes(staff) && staff.status === 'active'">
                <v-flex
                  v-if="!sameServiceDays"
                  class="pr-2 action-link"
                  @click="vEmit({ name: 'EditShiftAddress', data: { items, edit: 'single', day: item.day } })"
                  >Edit <v-icon>edit</v-icon>
                </v-flex>
                <v-flex
                  v-else
                  class="pr-2 action-link"
                  @click="vEmit({ name: 'EditShiftAddress', data: { items, edit: 'all' } })"
                  >Edit <v-icon>edit</v-icon>
                </v-flex>
              </template>
              <v-flex
                v-else
                class="pr-2 action-link grey--text"
                >Edit <v-icon class="grey--text">edit</v-icon>
              </v-flex>
            </v-flex>
          </td>
        </tr>
      </template>
    </v-data-table>
    <edit-shift-address @done="getAddresses"></edit-shift-address>
  </v-card>
</template>

<script>
import ApiService from "@/common/api.service"
import EventBus from "@/main"
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import { valMessages, getValMessage } from "@/common/error-messages"
import EditShiftAddress from './EditShiftAddress'
import { mapActions } from 'vuex'

export default {
  name: "ShiftAddress",
  components: {
    EditShiftAddress
  },
  props: ['states', 'staff'],
  data() {
    return {
      no_data: [null, "", undefined, "null"],
      items: [],
      loading: false,
      sameServiceDays: false,
      headers: [
        {
          text: "Service Days",
          value: "day",
          sortable: false
        },
        {
          text: "Start Address",
          value: "start_address",
          sortable: false
        },
        {
          text: "End Address",
          value: "address_address",
          sortable: false
        },
        {
          text: "Actions",
          sortable: false,
          width: "100px",
          align: "left"
        }
      ],
      days: [
        { id: 1, name: 'Monday', short: 'Mon'},
        { id: 2, name: 'Tuesday', short: 'Tue'},
        { id: 3, name: 'Wednesday', short: 'Wed'},
        { id: 4, name: 'Thursday', short: 'Thu'},
        { id: 5, name: 'Friday', short: 'Fri'},
        { id: 6, name: 'Saturday', short: 'Sat'},
        { id: 7, name: 'Sunday', short: 'Sun'},
      ],
    }
  },
  mounted () {
    this.getAddresses()
  },
  methods: {
    ...mapActions(['vEmit']),
    getAddresses () {
      this.loading = true
      ApiService.get(`/employee/location/${this.$route.params.id}`)
        .then(response => {
          this.items = response.data.locations

          const mappedItems = this.items.map(i => {
            return `${i.start_address
                    },${i.start_city
                    },${i.start_state
                    },${i.start_zip
                    },${i.end_address
                    },${i.end_city
                    },${i.end_state
                    },${i.end_zip}`
          })
          const uniqueItems = [...new Set(mappedItems)]
          this.sameServiceDays = uniqueItems.length === 1

          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    stateAbbr(state) {
      let out = String(state)
      if(this.states.some(i => i.name === state) && this.states.length !== 0) {
        out = this.states.find(i => i.name === state).full_name.split(' - ')[1]
      }
      return out
    }
  },
  computed: {
    filteredItems() {
      if(this.sameServiceDays) {
        return [this.items[0]]
      } else {
        return this.items
      }
    }
  }
}
</script>